"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface RejectOrderDialogProps {
  open: boolean;
  onClose: () => void;
  onReject: () => void;
}

export function RejectOrderDialog({
  open,
  onClose,
  onReject,
}: RejectOrderDialogProps) {
  const handleReject = () => {
    onReject();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md border-0 shadow-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-gray-800">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Recusar Pré-Pedido
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <p className="text-sm text-gray-600">
            Você está prestes a recusar este pré-pedido. Esta ação não pode ser
            desfeita.
          </p>
        </div>
        <DialogFooter className="sm:justify-between">
          <Button
            variant="outline"
            onClick={onClose}
            className="border-gray-200"
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={handleReject}
            className="bg-red-500 hover:bg-red-600"
          >
            Confirmar Recusa
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
